// AUTO-GENERATED from `pine_small.json` — do not edit by hand. Regenerate via the preset
//   → `.ts` conversion script when the upstream preset JSONs change.
import type {DeepPartial, TreeOptions} from "../options.js";

const options: DeepPartial<TreeOptions> = {
    "seed": 11744,
    "type": "evergreen",
    "bark": {
      "type": "Bark003",
      "tint": 16777215,
      "flatShading": false,
      "textured": true,
      "textureScale": {
        "x": 1,
        "y": 1
      }
    },
    "branch": {
      "levels": 1,
      "angle": {
        "1": 117,
        "2": 60,
        "3": 60
      },
      "children": {
        "0": 91,
        "1": 7,
        "2": 5
      },
      "force": {
        "direction": {
          "x": 0,
          "y": 1,
          "z": 0
        },
        "strength": 0
      },
      "gnarliness": {
        "0": 0.05,
        "1": 0.08,
        "2": 0,
        "3": 0
      },
      "length": {
        "0": 39.55,
        "1": 12.12,
        "2": 10,
        "3": 1
      },
      "radius": {
        "0": 0.55,
        "1": 0.41,
        "2": 0.7,
        "3": 0.7
      },
      "sections": {
        "0": 12,
        "1": 10,
        "2": 8,
        "3": 6
      },
      "segments": {
        "0": 8,
        "1": 6,
        "2": 4,
        "3": 3
      },
      "start": {
        "1": 0.16,
        "2": 0.3,
        "3": 0.3
      },
      "taper": {
        "0": 0.7,
        "1": 0.7,
        "2": 0.7,
        "3": 0.7
      },
      "twist": {
        "0": 0,
        "1": 0,
        "2": 0,
        "3": 0
      }
    },
    "leaves": {
      "type": "pine",
      "billboard": "double",
      "angle": 10,
      "count": 21,
      "start": 0,
      "size": 0.965,
      "sizeVariance": 0.7,
      "tint": 16777215,
      "alphaTest": 0.3
    },
    "trellis": {
      "enabled": false
    }
  };

export default options;
